export function EmptyCartPlaceholder() {
	return <main className={`cart cart--empty`}>
		<div class="cart__empty">
			<h3>Your cart is empty.</h3>
			<p><a href="/products">Start designing</a> or check out our <a href="/design-services">services</a></p>
		</div>
	</main>;
}
